import React, {Component} from 'react';
import {NavBar} from 'antd-mobile';
import './style.less';

export default class AboutMintu extends Component {
    constructor(props) {
        super(props);
        this.state = {
        };
    }

    
    componentDidMount() {

    }

    render() {
        return (
            <div className="aboutMintu">
                <NavBar
                    className="navBar"
                    mode="light"
                    icon={<i className="icon iconfont iconfanhui" onClick={() => this.props.history.goBack()}></i>}
                >帮助中心</NavBar>
                <div className="contentBox">
                    <div className="title">出行服务</div>
                    <div className="first">
                        <div>1.根据网约车监管政策要求，乘车应携带有效证件，上车前需要实名登记。</div>
                        <div>2. 应国家相关法律法规的要求，婴幼儿乘车需要计费，详细规则请查看《乘车须知》中有关婴幼儿乘车的规定。</div>
                        <div>3.携带宠物乘车的乘客，请在下单前请与客服联系，确认预约车辆是否允许携带宠物。</div>
                        <div>4.携带行李乘车的乘客，请详细阅读《乘车须知》中有关行李重量和尺寸的规定。</div>
                        {/* <div>“民途出行”是按照国家法规设计、开发的网络预约出租车运营综合管理平台，
                            符合《网络预约出租汽车经营服务管理暂行办法》各项具体要求。“民途出行”平台业务体系涵盖预约出行、接送机运营业务。
                            公司“网约车”车载硬件设备，包括：车辆卫星定位装置、网约出租车应急报警装置、车辆网络终端设备、车辆监控装置、计程计价设备等；
                            符合国家有关规定及应用标准要求。目前，公司以昆明为辐射中心向各州、市、县、乡开展相关业务，
                            联合当地运输企业及个人开展在线约车业务。</div> */}
                      
                    </div>
                </div>
            </div>
        )
    }
}


// WEBPACK FOOTER //
// ./src/container/member/HelpCenter/AboutMintu/index.js